import { render } from "./ModalInformativoSaibaMais.vue?vue&type=template&id=5370dc50"
import script from "./ModalInformativoSaibaMais.vue?vue&type=script&lang=js"
export * from "./ModalInformativoSaibaMais.vue?vue&type=script&lang=js"

import "./ModalInformativoSaibaMais.vue?vue&type=style&index=0&id=5370dc50&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__